import React, { Fragment, useEffect, useContext, useState } from 'react';
import { useHistory } from 'react-router';
import axios from 'axios';
import { authContext } from '../../context/AuthContext';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import withStyles from '@mui/styles/withStyles';

import Grid from '@mui/material/Grid';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";

const ContactTemplate = props => {

    const context = useContext(authContext)

    const history = useHistory()
    const [formState, setFormState] = useState({
        id: props.match.params.id,
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
    })

    // error is never used
    //const [formError, setError] = useState(null)

    const onChange = event => {
        setFormState({
            ...formState,
            [event.target.name]: event.target.value
        });
    }

    const onCreate = (event) => {
        var url = "/api/contactTemplate";
        let token = sessionStorage.getItem('accessToken');

        var data = {
            firstName: formState.firstName,
            lastName: formState.lastName,
            email: formState.email,
            phone: formState.phone,
            byUsername : context.user.username
        }
        axios(url, 
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data})
        .then(response => {
            if (response.status === 200) {
                history.goBack();
            }
        });
    }

    const onUpdate = (event) => {
        let token = sessionStorage.getItem('accessToken');

        var url = "/api/contactTemplate/" + formState.id;
        var data = {
            firstName: formState.firstName,
            lastName: formState.lastName,
            email: formState.email,
            phone: formState.phone,
            byUsername : context.user.username
        }
        axios(url, 
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data
            })
        .then(response => {
            if (response.status === 200) {
                history.goBack();
            }
        });
    }

    useEffect(()=>{
        async function getData() {
            var url = "/api/contactTemplate/" + props.match.params.id;

            let p = await axios.get(url)
            setFormState({
                id: p.data.template.ID,
                firstName: p.data.template.firstName,
                lastName: p.data.template.lastName,
                phone: p.data.template.phone,
                email: p.data.template.email,
            });
        }
        if (props.match.params.id !== undefined) {
           getData()
        }   
    },[props.match.params.id])


    const { classes } = props;

    return (
        <ValidatorForm
            noValidate
            onSubmit={formState.id === undefined ? onCreate : onUpdate}
        >
            <Fragment>
                <PageHeader
                    title={"Contact Template"}
                    cancel={history.goBack}
                    actionButtons={[{ label: formState.id === undefined ? "Add" : "Update" }]}
                />

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="First Name"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={onChange}
                            value={formState.firstName}
                            name='firstName'
                            validators={['required']}
                            errorMessages={['First name is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="Last Name"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={onChange}
                            value={formState.lastName}
                            name='lastName'
                            validators={['required']}
                            errorMessages={['Last name is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="Phone"
                            type="tel"
                            className={[classes.textField].join(' ')}
                            placeholder='987-654-3210 x1234'
                            onChange={onChange}
                            value={formState.phone}
                            name='phone'
                            // '(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4}) (\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+) )?'
                            validators={['required', 'matchRegexp:^(\\+\\d{1,3}\\s?)?((\\(\\d{3}\\)\\s?)|(\\d{3})(\\s|-?))(\\d{3}(\\s|-?))(\\d{4})(\\s?(([E|e]xt[:|.|]?)|x|X)(\\s?\\d+))?$']}
                            errorMessages={['Phone is required', 'Only "(", ")", "-", "x", and numbers are allowed. Must be at least 10 digits']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="Email"
                            type="email"
                            className={[classes.textField].join(' ')}
                            onChange={onChange}
                            value={formState.email}
                            name='email'
                            validators={['required', 'isEmail']}
                            errorMessages={['Email is required', 'Please enter a valid email address']}
                            fullWidth
                            required
                        />
                    </Grid>
                </Grid>
            </Fragment>
        </ValidatorForm>
    );

}

// export default ContactTemplate;
export default withStyles(styles, { withTheme: true })(ContactTemplate);
